import type * as core from '../../../../../../../core'

export const query: core.mosaic.Widget.Query = {
  selection: {
    '{}': {
      name: 'Anticipated Response of Change by Functional Area',
      type: 'charts',
      content: {
        '{}': {
          data: {
            '[]': [
              {
                '{}': {
                  name: 'Anticipated Response of Change',
                  values: {
                    '[]': [
                      {
                        '{}': {
                          name: 'Positive',
                          points: {
                            '[]': [
                              {
                                '{}': {
                                  x: 'Build / Functional',
                                  y: {
                                    '#': {
                                      '@': 'positiveBuildFunctional',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Change Management',
                                  y: {
                                    '#': {
                                      '@': 'positiveChangeManagement',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Data Integration',
                                  y: {
                                    '#': {
                                      '@': 'positiveDataIntegration',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Data Migration',
                                  y: {
                                    '#': {
                                      '@': 'positiveDataMigration',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Marketing Cloud',
                                  y: {
                                    '#': {
                                      '@': 'positiveMarketingCloud',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Project Management',
                                  y: {
                                    '#': {
                                      '@': 'positiveProjectManagement',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Reporting & Analytics',
                                  y: {
                                    '#': {
                                      '@': 'positiveReportingAndAnalytics',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Technical',
                                  y: {
                                    '#': {
                                      '@': 'positiveTechnical',
                                    },
                                  },
                                },
                              },
                            ],
                          },
                        },
                      },
                      {
                        '{}': {
                          name: 'Neutral',
                          points: {
                            '[]': [
                              {
                                '{}': {
                                  x: 'Build / Functional',
                                  y: {
                                    '#': {
                                      '@': 'neutralBuildFunctional',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Change Management',
                                  y: {
                                    '#': {
                                      '@': 'neutralChangeManagement',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Data Integration',
                                  y: {
                                    '#': {
                                      '@': 'neutralDataIntegration',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Data Migration',
                                  y: {
                                    '#': {
                                      '@': 'neutralDataMigration',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Marketing Cloud',
                                  y: {
                                    '#': {
                                      '@': 'neutralMarketingCloud',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Project Management',
                                  y: {
                                    '#': {
                                      '@': 'neutralProjectManagement',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Reporting & Analytics',
                                  y: {
                                    '#': {
                                      '@': 'neutralReportingAndAnalytics',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Technical',
                                  y: {
                                    '#': {
                                      '@': 'neutralTechnical',
                                    },
                                  },
                                },
                              },
                            ],
                          },
                        },
                      },
                      {
                        '{}': {
                          name: 'Negative',
                          points: {
                            '[]': [
                              {
                                '{}': {
                                  x: 'Build / Functional',
                                  y: {
                                    '#': {
                                      '@': 'negativeBuildFunctional',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Change Management',
                                  y: {
                                    '#': {
                                      '@': 'negativeChangeManagement',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Data Integration',
                                  y: {
                                    '#': {
                                      '@': 'negativeDataIntegration',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Data Migration',
                                  y: {
                                    '#': {
                                      '@': 'negativeDataMigration',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Marketing Cloud',
                                  y: {
                                    '#': {
                                      '@': 'negativeMarketingCloud',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Project Management',
                                  y: {
                                    '#': {
                                      '@': 'negativeProjectManagement',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Reporting & Analytics',
                                  y: {
                                    '#': {
                                      '@': 'negativeReportingAndAnalytics',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Technical',
                                  y: {
                                    '#': {
                                      '@': 'negativeTechnical',
                                    },
                                  },
                                },
                              },
                            ],
                          },
                        },
                      },
                      {
                        '{}': {
                          name: 'Mixed',
                          points: {
                            '[]': [
                              {
                                '{}': {
                                  x: 'Build / Functional',
                                  y: {
                                    '#': {
                                      '@': 'mixedBuildFunctional',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Change Management',
                                  y: {
                                    '#': {
                                      '@': 'mixedChangeManagement',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Data Integration',
                                  y: {
                                    '#': {
                                      '@': 'mixedDataIntegration',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Data Migration',
                                  y: {
                                    '#': {
                                      '@': 'mixedDataMigration',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Marketing Cloud',
                                  y: {
                                    '#': {
                                      '@': 'mixedMarketingCloud',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Project Management',
                                  y: {
                                    '#': {
                                      '@': 'mixedProjectManagement',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Reporting & Analytics',
                                  y: {
                                    '#': {
                                      '@': 'mixedReportingAndAnalytics',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Technical',
                                  y: {
                                    '#': {
                                      '@': 'mixedTechnical',
                                    },
                                  },
                                },
                              },
                            ],
                          },
                        },
                      },
                      {
                        '{}': {
                          name: 'Unknown',
                          points: {
                            '[]': [
                              {
                                '{}': {
                                  x: 'Build / Functional',
                                  y: {
                                    '#': {
                                      '@': 'unknownBuildFunctional',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Change Management',
                                  y: {
                                    '#': {
                                      '@': 'unknownChangeManagement',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Data Integration',
                                  y: {
                                    '#': {
                                      '@': 'unknownDataIntegration',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Data Migration',
                                  y: {
                                    '#': {
                                      '@': 'unknownDataMigration',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Marketing Cloud',
                                  y: {
                                    '#': {
                                      '@': 'unknownMarketingCloud',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Project Management',
                                  y: {
                                    '#': {
                                      '@': 'unknownProjectManagement',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Reporting & Analytics',
                                  y: {
                                    '#': {
                                      '@': 'unknownReportingAndAnalytics',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Technical',
                                  y: {
                                    '#': {
                                      '@': 'unknownTechnical',
                                    },
                                  },
                                },
                              },
                            ],
                          },
                        },
                      },
                    ],
                  },
                  xLabel: 'Functional Area',
                  yLabel: 'Count',
                },
              },
            ],
          },
          type: 'bar.stacked',
        },
      },
    },
  },
  subqueries: {
    mixedTechnical: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Technical',
            ],
          },
          {
            '=': [
              {
                '@.': '!anticipated_response_of_change',
              },
              'Mixed',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    neutralTechnical: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Technical',
            ],
          },
          {
            '=': [
              {
                '@.': '!anticipated_response_of_change',
              },
              'Neutral',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    unknownTechnical: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Technical',
            ],
          },
          {
            '=': [
              {
                '@.': '!anticipated_response_of_change',
              },
              'Unknown',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    negativeTechnical: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Technical',
            ],
          },
          {
            '=': [
              {
                '@.': '!anticipated_response_of_change',
              },
              'Negative',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    positiveTechnical: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Technical',
            ],
          },
          {
            '=': [
              {
                '@.': '!anticipated_response_of_change',
              },
              'Positive',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    mixedDataMigration: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Data Migration',
            ],
          },
          {
            '=': [
              {
                '@.': '!anticipated_response_of_change',
              },
              'Mixed',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    mixedMarketingCloud: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Marketing Cloud',
            ],
          },
          {
            '=': [
              {
                '@.': '!anticipated_response_of_change',
              },
              'Mixed',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    mixedBuildFunctional: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Build / Functional',
            ],
          },
          {
            '=': [
              {
                '@.': '!anticipated_response_of_change',
              },
              'Mixed',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    mixedDataIntegration: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Data Integration',
            ],
          },
          {
            '=': [
              {
                '@.': '!anticipated_response_of_change',
              },
              'Mixed',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    neutralDataMigration: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Data Migration',
            ],
          },
          {
            '=': [
              {
                '@.': '!anticipated_response_of_change',
              },
              'Neutral',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    unknownDataMigration: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Data Migration',
            ],
          },
          {
            '=': [
              {
                '@.': '!anticipated_response_of_change',
              },
              'Unknown',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    mixedChangeManagement: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Change Management',
            ],
          },
          {
            '=': [
              {
                '@.': '!anticipated_response_of_change',
              },
              'Mixed',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    negativeDataMigration: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Data Migration',
            ],
          },
          {
            '=': [
              {
                '@.': '!anticipated_response_of_change',
              },
              'Negative',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    neutralMarketingCloud: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Marketing Cloud',
            ],
          },
          {
            '=': [
              {
                '@.': '!anticipated_response_of_change',
              },
              'Neutral',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    positiveDataMigration: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Data Migration',
            ],
          },
          {
            '=': [
              {
                '@.': '!anticipated_response_of_change',
              },
              'Positive',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    unknownMarketingCloud: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Marketing Cloud',
            ],
          },
          {
            '=': [
              {
                '@.': '!anticipated_response_of_change',
              },
              'Unknown',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    mixedProjectManagement: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Project Management',
            ],
          },
          {
            '=': [
              {
                '@.': '!anticipated_response_of_change',
              },
              'Mixed',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    negativeMarketingCloud: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Marketing Cloud',
            ],
          },
          {
            '=': [
              {
                '@.': '!anticipated_response_of_change',
              },
              'Negative',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    neutralBuildFunctional: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Build / Functional',
            ],
          },
          {
            '=': [
              {
                '@.': '!anticipated_response_of_change',
              },
              'Neutral',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    neutralDataIntegration: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Data Integration',
            ],
          },
          {
            '=': [
              {
                '@.': '!anticipated_response_of_change',
              },
              'Neutral',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    positiveMarketingCloud: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Marketing Cloud',
            ],
          },
          {
            '=': [
              {
                '@.': '!anticipated_response_of_change',
              },
              'Positive',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    unknownBuildFunctional: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Build / Functional',
            ],
          },
          {
            '=': [
              {
                '@.': '!anticipated_response_of_change',
              },
              'Unknown',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    unknownDataIntegration: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Data Integration',
            ],
          },
          {
            '=': [
              {
                '@.': '!anticipated_response_of_change',
              },
              'Unknown',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    negativeBuildFunctional: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Build / Functional',
            ],
          },
          {
            '=': [
              {
                '@.': '!anticipated_response_of_change',
              },
              'Negative',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    negativeDataIntegration: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Data Integration',
            ],
          },
          {
            '=': [
              {
                '@.': '!anticipated_response_of_change',
              },
              'Negative',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    neutralChangeManagement: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Change Management',
            ],
          },
          {
            '=': [
              {
                '@.': '!anticipated_response_of_change',
              },
              'Neutral',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    positiveBuildFunctional: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Build / Functional',
            ],
          },
          {
            '=': [
              {
                '@.': '!anticipated_response_of_change',
              },
              'Positive',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    positiveDataIntegration: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Data Integration',
            ],
          },
          {
            '=': [
              {
                '@.': '!anticipated_response_of_change',
              },
              'Positive',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    unknownChangeManagement: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Change Management',
            ],
          },
          {
            '=': [
              {
                '@.': '!anticipated_response_of_change',
              },
              'Unknown',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    negativeChangeManagement: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Change Management',
            ],
          },
          {
            '=': [
              {
                '@.': '!anticipated_response_of_change',
              },
              'Negative',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    neutralProjectManagement: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Project Management',
            ],
          },
          {
            '=': [
              {
                '@.': '!anticipated_response_of_change',
              },
              'Neutral',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    positiveChangeManagement: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Change Management',
            ],
          },
          {
            '=': [
              {
                '@.': '!anticipated_response_of_change',
              },
              'Positive',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    unknownProjectManagement: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Project Management',
            ],
          },
          {
            '=': [
              {
                '@.': '!anticipated_response_of_change',
              },
              'Unknown',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    negativeProjectManagement: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Project Management',
            ],
          },
          {
            '=': [
              {
                '@.': '!anticipated_response_of_change',
              },
              'Negative',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    positiveProjectManagement: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Project Management',
            ],
          },
          {
            '=': [
              {
                '@.': '!anticipated_response_of_change',
              },
              'Positive',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    mixedReportingAndAnalytics: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Reporting & Analytics',
            ],
          },
          {
            '=': [
              {
                '@.': '!anticipated_response_of_change',
              },
              'Mixed',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    neutralReportingAndAnalytics: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Reporting & Analytics',
            ],
          },
          {
            '=': [
              {
                '@.': '!anticipated_response_of_change',
              },
              'Neutral',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    unknownReportingAndAnalytics: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Reporting & Analytics',
            ],
          },
          {
            '=': [
              {
                '@.': '!anticipated_response_of_change',
              },
              'Unknown',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    negativeReportingAndAnalytics: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Reporting & Analytics',
            ],
          },
          {
            '=': [
              {
                '@.': '!anticipated_response_of_change',
              },
              'Negative',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    positiveReportingAndAnalytics: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Reporting & Analytics',
            ],
          },
          {
            '=': [
              {
                '@.': '!anticipated_response_of_change',
              },
              'Positive',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
  },
}
